import { render, staticRenderFns } from "./added_my_lists.vue?vue&type=template&id=09e4c870&lang=pug&"
import script from "./added_my_lists.vue?vue&type=script&lang=js&"
export * from "./added_my_lists.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports